module.exports = __webpack_public_path__ + "media/snap.00b7f5bc.mp3";